import { Box } from "@material-ui/core";

const Space = (props) => {
  return <Box style={{ width: "100%", height: props.height }}></Box>;
};

export default Space;
